import { RESET_SETTINGS_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[RESET_SETTINGS_FORM]();
